<template>
  <div class="mainContainer">
    <el-table ref="plxTable" :data="tableData" max-height="500" highlight-current-row border stripe>
      <el-table-column align="center" label="评价月" prop="month" min-width="100"></el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="Category2" prop="category2Name" min-width="100"></el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="Facility编号" prop="facilityCode" min-width="120"></el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="Facility名称" prop="facilityName" min-width="180"></el-table-column>
      <el-table-column align="center" label="等级" prop="grade" min-width="80"></el-table-column>
      <el-table-column align="center" label="分数" prop="score" min-width="80"></el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="Comment" prop="remark" min-width="200"></el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="截止日期" prop="deadline" min-width="100"></el-table-column>
      <el-table-column align="center" label="状态" prop="statusI18n" min-width="100"></el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="更新人" prop="updateName" min-width="100"></el-table-column>
      <el-table-column show-overflow-tooltip align="center" label="更新日期" prop="updateDate" min-width="100"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import otherApi from "@/api/other/index";
export default {
  name: '',
  components: {

  },
  props: ['arr'],
  data() {
    return {
      tableData: [],
    }
  },
  created() {
  },
  watch: {
    arr:{
      handler(newV,oldV){
        console.log('newV',newV);
        this.tableData=JSON.parse(newV)
      },
      immediate:true
    }
  },
  methods: {

  },
}
</script>
<style scoped >
</style>
